import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Our components
import Notification from '../../../pages/General/Notification'
import NorowsData from '../../../pages/General/NorowsData'
import KitDetailsForm from '../../../pages/General/KitDetailsForm'


// mui components
import {
    FormControl,
    Pagination,
    IconButton,
    Button,
    Tooltip,
    Box,
    TextField,
    Modal,
    Autocomplete,
    MenuItem,
    styled,
    Tabs,
    Tab,
    Typography,
    Select,
    InputLabel
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import UploadIcon from '@mui/icons-material/Upload';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Chip from "@mui/material/Chip";
import { CircularProgress } from '@mui/material';
import {
    DataGrid,
    GridToolbarContainer,
    GridFooterContainer,
    // DataGridPro
} from '@mui/x-data-grid';

import { fetchLineItemsData, importProducts, fetchNewLineItemsData, updateLineItems,
     destoryLineitems, storeNewProduct, resetLineItemSettingsState, fetchKitLineItemsData,fetchSkuINfo } from './lineitemSettingsSlice';
import { fetchCountry } from '../../../pages/General/countryStateCitySlice';
// import Filters from './Filters'
const Input = styled('input')({
    display: 'none',
});
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper'
};
const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
const ProductLineItemsPage = () => {
    const dispatch = useDispatch();
    const lineitemsettings = useSelector(state => state.lineitemsettings.orderLineItemData);
    const newlineitemsettings = useSelector(state => state.lineitemsettings.NewrOrderLineItemData);
    const kitlineitemsettings = useSelector(state => state.lineitemsettings.kitOrderLineItemData);
    const importproduct = useSelector(state => state.lineitemsettings.importproducts);
    const lineitemsnotify = useSelector(state => state.lineitemsettings.lineitemsnotify);
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code);
    const profile = useSelector(state => state.auth.profile);
    const skuInfos = useSelector(state => state.lineitemsettings.skuINfo);
    const [meta, setMeta] = useState(lineitemsettings.meta);
    const [newMeta, setNewMeta] = useState(newlineitemsettings.newMeta);
    const [kitMeta, setKitMeta] = useState(kitlineitemsettings.kitMeta);
    const [selectedItem, setSelectedItem] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [originCountryCode, setOriginCountryCode] = useState("");
    const [hsTariffcode, setHsTariffcode] = useState("");
    const [hsTariffcodeCountry, setHsTariffcodeCountry] = useState("");
    const [productId, setProductId] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [sku, setSku] = useState("");
    const [fda, setFda] = useState("");
    const [currency, setCurrency] = useState("");
    const [productValue, setProductValue] = useState("");
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [modalImportVisible, setModalImportVisible] = useState(false);
    const [fileUpload, setFileUpload] = useState("")
    const [fileName, setFileName] = useState("")
    const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(true)
    const [buttonUploadDisabled, setButtonUploadDisabled] = useState(false)
    const [value, setValue] = React.useState(0);
    const [id, setId] = React.useState("");
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [modalTitle, setModalTitle] = useState(value === 1 ? "Items Edit" : "New Items Edit");
    const [originCountryCodeError, setOriginCountryCodeError] = React.useState("");
    const [skuError, setSkuError] = React.useState("");
    const [productDescError, setProductDescError] = React.useState("");
    const [hsTariffcodeError, setHsTariffcodeError] = React.useState("");
    const [hsTariffcodeCountryError, setHsTariffcodeCountryError] = React.useState("");
    const [currencyError, setCurrencyError] = React.useState("");
    const [productValueError, setproductValueError] = React.useState("");
    const [quantity, setQuantity] = useState("");
    const [quantityError, setQuantityError] = React.useState("");
    const [isKit, setIsKit] = React.useState(false);
    const [itemSku, setItemSku] = useState("");
    const [skuInfo, setSkuInfo] = useState([]);
    const [itemSkuError, setItemSkuError] = React.useState("");
    const [skuFilter, setSkuFilter] = React.useState("");
    const [isKitFilter, setIsKitFilter] = React.useState("");
    const [kitItemDetails, setKitItemDetails] = React.useState([]);
    const [kitReady, setKitReady] = useState(false);
    const [kitLoading, setKitLoading] = useState(false);
    let columns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'product_desc',
            headerName: 'Description',
            flex: 1
        },
        {
            field: 'product_price',
            headerName: 'Product Value',
            flex: 1,
            renderCell: (params) => {
                return <span>{params.row.product_price+" "+params.row.currency}</span>
            }
        },
        {
            field: 'quantity',
            headerName: 'Stock Quantity',
            flex: 1
        },
        {
            field: 'hs_tariff_code',
            headerName: 'Hs Code',
            flex: 1
        },
        {
            field: 'origin_country_code',
            headerName: 'COO',
            flex: 1
        },
        {
            field: "is_kit",
            headerName: "Is Kit",
            width: 100,
            renderCell: (params) => {
                return (
                <div>
                    {params.row.is_kit == true && (
                    <Chip
                        label="Yes"
                        color="success"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                    {!params.row.is_kit && (
                    <Chip
                        label="No"
                        color="error"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                </div>
                );
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                    </span>
                </div>
            }
        },
    ]

    let newColumns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'product_id',
            headerName: 'ProductId',
            flex: 1
        },
        {
            field: 'product_desc',
            headerName: 'Description',
            flex: 1
        },
        {
            field: 'product_price',
            headerName: 'Product Value',
            flex: 1,
            renderCell: (params) => {
                return <span>{params.row.product_price+" "+params.row.currency}</span>
            }
        },
        {
            field: 'quantity',
            headerName: 'Stock Quantity',
            flex: 1
        },
        {
            field: 'hs_tariff_code',
            headerName: 'Hs Code',
            flex: 1
        },
        {
            field: 'origin_country_code',
            headerName: 'COO',
            flex: 1
        },
        {
            field: "is_kit",
            headerName: "Is Kit",
            width: 100,
            renderCell: (params) => {
                return (
                <div>
                    {params.row.is_kit == true && (
                    <Chip
                        label="Yes"
                        color="success"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                    {!params.row.is_kit && (
                    <Chip
                        label="No"
                        color="error"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                </div>
                );
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setKitReady(false); // ⛔ prevent stale render
                                    setKitLoading(true); // 🔄 show spinner
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                    if(params.row.is_kit){
                                        dispatch(fetchSkuINfo(params.row.sku,"INVENTORY"))
                                    }
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}
                                        onClick={(e) => {
                                            handleOnClickDelete(params.row.id)
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </span>
                </div>
            }
        },
    ]

    let kitColumns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'item_sku',
            headerName: 'Item Sku',
            flex: 1
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            flex: 1,
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                   
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}
                                        onClick={(e) => {
                                            handleOnClickDelete(params.row.id)
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </span>
                </div>
            }
        },
    ]

    const onSortChange = (currentSorting) => {
        // Only update if there's actually a sort applied, otherwise reset to empty array
        const sortingValue = currentSorting.length > 0 ? JSON.stringify(currentSorting) : "";

        // Check which tab is active and update the corresponding meta
        if (value === 1) {
            setMeta({
                ...meta,
                page: 1, // reset to page 1 on sort
                sorting: sortingValue
            });
        } else if (value === 0) {
            setNewMeta({
                ...newMeta,
                page: 1,
                sorting: sortingValue
            });
        } else {
            setKitMeta({
                ...kitMeta,
                page: 1,
                sorting: sortingValue
            });
        }
    };

    const handleOnClickDelete = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };

    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deleteaddress = (id) => {
        dispatch(destoryLineitems(profile && profile.id,id,value))
        setDeleteModalopen(false);
    }

    const validateCurrency = (value) => {
        const regex = /^[A-Za-z]{3}$/; // Only 3 alphabetic characters
        if (!value) {
            return "Currency is required";
        } else if (!regex.test(value)) {
            return "Enter exactly 3 letters (e.g., USD)";
        }
        return "";
    };

    const handleInput = (e) => {
        const value = e.target.value.toUpperCase(); // Optional: auto-uppercase
        setCurrency(value);
        setCurrencyError(""); // Clear error while typing
    };

    const handleBlur = () => {
        const error = validateCurrency(currency);
        setCurrencyError(error);
    };

    const handleHscodeInput = (e) => {
        setHsTariffcode(e.target.value)
        setHsTariffcodeError("")
    };

    const handleHsCodeBlur = () => {
        if(hsTariffcode!=="" && hsTariffcode!==undefined){
            const raw = hsTariffcode.replace(/\D/g, ''); // Remove non-digits
            if (raw.length === 10) {
                const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;
                setHsTariffcode(formatted)
                setHsTariffcodeError("")
            }else{
                setHsTariffcodeError("Hs code must be 10 digits")
            }
        }
    };


    const validateProductValue = (value) => {
        const numericRegex = /^-?\d+(\.\d+)?$/; // Matches integers and decimals
        if (!value) {
            return "Product value is required";
        } else if (!numericRegex.test(value)) {
            return "Only numeric values allowed (e.g., 123 or 123.45)";
        } else if (parseFloat(value) > 5000) {
            return "Product value must not exceed 5000";
        }
        return "";
    };

    const handleProductValueInput = (e) => {
        const value = e.target.value.trim();
        setProductValue(value);
        setproductValueError(""); // Clear error while typing
    };

    const handleProductValueBlur = () => {
        const error = validateProductValue(productValue);
        setproductValueError(error);
    };

    const validateQuantity = (value) => {
        const integerRegex = /^([1-9]\d*|\s*)$/;

        if (!integerRegex.test(value)) {
            return "Only positive integers allowed (e.g., 1, 10, 250)";
        }
        return "";
    };

    const handleQuantityInput = (e) => {
        const value = e.target.value.trim();
        setQuantity(value);
        setQuantityError(""); // Clear error while typing
    };

    const handleQuantityBlur = () => {
        const error = validateQuantity(quantity);
        setQuantityError(error);
    };

    const kitFormRef = useRef();
    const handleSubmit = (e, value,tabValue) => {
        let validatedRows = null;
         // ✅ Only validate kit rows if isKit is true
        if (isKit) {
            validatedRows = kitFormRef.current?.validateAndGetRows();
            if (!validatedRows) {
            console.log('Validation failed in KitDetailsForm');
            return; // Stop submission if kit validation fails
            }
        }
        if(hsTariffcodeError!==""){
            return;
        }
        if (!value.includes('Bulk Edit') && (sku === "" || sku === null || sku === undefined)) {
            setSkuError("Sku is required")
        }else if (tabValue!==2 && !value.includes('Bulk Edit') && (productDescription === "" || productDescription === null || productDescription === undefined)) {
            setProductDescError("Product Description field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (productValue === "" || productValue === null || productValue === undefined)) {
            setproductValueError("Product value field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (currency === "" || currency === null || currency === undefined)) {
            setCurrencyError("Currency field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (hsTariffcode === ""|| hsTariffcode === null || hsTariffcode === undefined)) {
            setHsTariffcodeError("Hstariffcode field is required")
        }else if (tabValue!==2 && !isKit && !originCountryCode) {
            setOriginCountryCodeError("Origin country code Field is required")
        }else if (tabValue===2 && (quantity === ""|| quantity === null || quantity === undefined)) {
            setQuantityError("quantity field is required")
        }else if (tabValue===2 && (itemSku === ""|| itemSku === null || itemSku === undefined)) {
            setItemSkuError("Item sku field is required")
        }else {
            setOriginCountryCodeError("")
            if (value.includes("Items Edit") && tabValue!==2) {
                let finalData={}
                if(isKit){
                    finalData = {
                        "sku": sku,
                        "product_desc": productDescription,
                        "product_price": productValue,
                        "is_kit": isKit,
                        "type": value,
                        "item_details": validatedRows,
                        "id":id
                    }
                }else{
                    finalData = {
                        "product_desc": productDescription,
                        "product_id": productId,
                        "hs_tariff_code": hsTariffcode,
                        "origin_country_code": originCountryCode,
                        "product_price": productValue,
                        "currency": currency,
                        "sku": sku,
                        "quantity": quantity,
                        "type": value,
                        "is_kit": isKit,
                        "id":id
                    }
                }
                console.log(finalData)
                dispatch(updateLineItems(profile && profile.id,id, finalData));
            } else if (value.includes('Bulk Edit') && tabValue!==2) {
                let finalData = {};
                finalData = {
                    "product_desc": productDescription,
                    "hs_tariff_code": hsTariffcode,
                    "origin_country_code": originCountryCode,
                    "product_price": productValue,
                    "product_id": productId,
                    "currency": currency,
                    "skus": checkedIds,
                    "quantity": quantity,
                    "type": value,
                    "is_kit": isKit
                }
                dispatch(updateLineItems(profile && profile.id,1, finalData));
            } else if (value.includes('Add New') && tabValue!==2) {
                if(isKit){
                   let finalData = {
                        "sku": sku,
                        "product_desc": productDescription,
                        "product_price": productValue,
                        "is_kit": isKit,
                        "type": value,
                        "item_details": validatedRows
                    }
                    dispatch(storeNewProduct(profile && profile.id,finalData));
                }else{
                    let finalData = {
                        "product_id": productId,
                        "product_desc": productDescription,
                        "hs_tariff_code": hsTariffcode,
                        "origin_country_code": originCountryCode,
                        "sku": sku,
                        "product_price": productValue,
                        "quantity": quantity,
                        "currency": currency,
                        "is_kit": isKit
                    }
                    dispatch(storeNewProduct(profile && profile.id,finalData));
                }
            }else if (tabValue===2 && value.includes("Items Edit")) {
                let finalData = {
                    "sku": sku,
                    "item_sku": itemSku,
                    "quantity": quantity,
                    "type": value,
                    "tabValue": tabValue,
                    "is_kit":true,
                    "id":id
                }
              dispatch(updateLineItems(profile && profile.id,id, finalData));
            }
        }
    }


    const tabOnClick = (e, value) => {
        setValue(value);
        setCheckedIds([])
        setCheckedItems([])
        setSkuFilter("")
        if (value === 1) {
            setModalTitle("Items Edit")
            setMeta({
                ...meta,
                ...{
                    page: 1,
                }
            });
        } else if (value === 0) {
            setModalTitle("New Items Edit")
            setNewMeta({
                ...newMeta,
                ...{
                    page: 1,
                }
            });
        }else{
            setKitMeta({
                ...kitMeta,
                ...{
                    page: 1,
                }
            });
        }
    };

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const index = tempCheckedIds.indexOf(item.sku);
        const method = (currentSelectedIds.indexOf(item.sku) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(item.sku);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }
    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const handleClose = (event, reason) => {
        onModalImportClose();
    }

    const onFileUpload = (e) => {
        e.preventDefault()
        if (e.target.files && e.target.files.length === 0) {
            setFileName(fileUpload.name)
            setFileUpload(fileUpload);
        } else {
            setFileUpload(e.target.files[0]);
            setFileName(e.target.files[0].name)
        }
        setButtonSubmitDisabled(false)
    }

    const onSubmit = () => {
        var formData = new FormData();
        formData.append('file', fileUpload);
        formData.append("tabValue", value);
        dispatch(importProducts(formData))
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(true)
        setModalImportVisible(false)
    }

    const onModalImportClose = () => {
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(false)
        setModalImportVisible(false)
    }

    const onModalClose = (event, reason) => {
        if (reason && reason == "backdropClick"){
            return;
        }
        setModalVisible(false)
        setSelectedItem({})
        setOriginCountryCode("")
        setHsTariffcodeCountry("")
        setHsTariffcode("")
        setSku("")
        setFda("")
        setProductDescription("")
        setId("")
        setProductId("")
        setProductValue("")
        setCurrency("")
        setCheckedIds([])
        setCheckedItems([])
        setOriginCountryCodeError("")
        setProductDescError("")
        setSkuError("")
        setHsTariffcodeError("")
        setHsTariffcodeCountryError("")
        setCurrencyError("")
        setproductValueError("")
        setQuantityError("")
        setIsKit(false)
        setItemSkuError("")
        setItemSku("")
        
        if (value === 1) {
            setModalTitle("Items Edit")
        }else if (value === 2) {
            setModalTitle("Items Edit")
        }else {
            setModalTitle("New Items Edit")
        }
    }

    useEffect(() => {
           if(lineitemsnotify && lineitemsnotify.loading==false && lineitemsnotify.notification && lineitemsnotify.notification.messageContent  && lineitemsnotify.notification.messageContent[0] !==''  && lineitemsnotify.notification.messageType!=='error'){
                onModalClose()
           }
    }, [lineitemsnotify]);

    useEffect(() => {
        if (selectedItem && value!==2) {
            setOriginCountryCode(selectedItem.origin_country_code)
            setHsTariffcode(selectedItem.hs_tariff_code)
            setProductId(selectedItem.product_id)
            setProductDescription(selectedItem.product_desc)
            setSku(selectedItem.sku)
            setProductValue(selectedItem.product_price)
            setCurrency(selectedItem.currency)
            setFda(selectedItem.fda)
            setQuantity(selectedItem.quantity)
            setIsKit(selectedItem.is_kit===1 ? true :false)
        }else{
            setSku(selectedItem.sku)
            setQuantity(selectedItem.quantity)
            setItemSku(selectedItem.item_sku)
        }

    }, [selectedItem]);

    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
            if (key.code === country_code) {
                filteredValue = key;
            }
        });
        return filteredValue;
    };

    useEffect(() => {
        if (value === 1) {
            const updatedMeta = {
                ...meta,
                sku: skuFilter
            };
            dispatch(fetchLineItemsData(updatedMeta));
            dispatch(fetchCountry());
        }
    }, [dispatch, meta, value, skuFilter, isKitFilter]);

    useEffect(() => {
        if (value === 0) {
            const updatedMeta = {
                ...newMeta,
                sku: skuFilter,
                is_kit: isKitFilter,
            };
            dispatch(fetchNewLineItemsData(updatedMeta));
            dispatch(fetchCountry());
        }
    }, [dispatch, newMeta, value, skuFilter, isKitFilter]);

    useEffect(() => {
        if (value === 2) {
            const updatedMeta = {
                ...kitMeta,
                sku: skuFilter
            };
            dispatch(fetchKitLineItemsData(updatedMeta));
        }
    }, [dispatch, kitMeta,skuFilter, value]);

    useEffect(() => {
        if (skuInfos?.data?.skuDatas?.length > 0) {
            setKitItemDetails(skuInfos.data.skuDatas);
            setKitReady(true); // ✅ now child can render
            setKitLoading(false); // ✅ hide spinner
        }else{
            setKitItemDetails([]);
            setKitLoading(false);
            setKitReady(true);
        }if (skuInfos?.data?.skuInfos?.length > 0) {
            setSkuInfo(skuInfos.data.skuInfos);
        }
        
    }, [skuInfos]);

    const handleAddNew = () => {
        setKitItemDetails([]);         // ✅ clear previous child data
        setSelectedItem({});         // optional: clear selected SKU
        setKitReady(true);             // ✅ allow child to render immediately
        setModalVisible(true);    
        setKitLoading(false); // ✅ hide spinner     // open modal
    };

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    function CustomPagesizeoptions() {

        return (
            <div className="custom-page-size-options">
                <span>
                    Show <select
                        value={meta && meta.per_page}
                        onChange={onChangePerPage}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select> entries
                </span>
            </div>
        )
    }

    function CustomTotalRows() {

        return (
            <div className="custom-total-rows">
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    Showing {lineitemsettings && lineitemsettings.data && lineitemsettings.data.length} of {(lineitemsettings && lineitemsettings.meta && lineitemsettings.meta.total) ? lineitemsettings.meta.total : 0}
                </FormControl>
            </div>
        )
    }

    function CustomToolbar() {

        return (
            <GridToolbarContainer>
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }
    
    const onNewChangePerPage = (event) => {
        setNewMeta({
            ...newMeta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onNewChangePagination = (event, page) => {
        console.log(page)
        setNewMeta({
            ...newMeta,
            ...{
                page: page
            }
        });
    }

    const onKitChangePerPage = (event) => {
        setKitMeta({
            ...kitMeta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onKitChangePagination = (event, page) => {
        console.log(page)
        setKitMeta({
            ...kitMeta,
            ...{
                page: page
            }
        });
    }

    function CustomNewTotalRows() {

        return (
            <div className="custom-total-rows">
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    Showing {newlineitemsettings && newlineitemsettings.data && newlineitemsettings.data.length} of {(newlineitemsettings && newlineitemsettings.newMeta && newlineitemsettings.newMeta.total) ? newlineitemsettings.newMeta.total : 0}
                </FormControl>
            </div>
        )
    }

    function CustomNewPagesizeoptions() {

        return (
            <div className="custom-page-size-options">
                <span>
                    Show <select
                        value={newMeta && newMeta.per_page}
                        onChange={onNewChangePerPage}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select> entries
                </span>
            </div>
        )
    }

    function newCustomToolbar() {

        return (
            <GridToolbarContainer>
                <CustomNewPagesizeoptions />
                <CustomNewTotalRows />
            </GridToolbarContainer>
        );
    }

    function KitCustomNewTotalRows() {
        return (
            <div className="custom-total-rows">
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    Showing {kitlineitemsettings && kitlineitemsettings.data && kitlineitemsettings.data.length} of {(kitlineitemsettings && kitlineitemsettings.kitMeta && kitlineitemsettings.kitMeta.total) ? kitlineitemsettings.kitMeta.total : 0}
                </FormControl>
            </div>
        )
    }

    function KitCustomNewPagesizeoptions() {

        return (
            <div className="custom-page-size-options">
                <span>
                    Show <select
                        value={kitMeta && kitMeta.per_page}
                        onChange={onKitChangePerPage}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select> entries
                </span>
            </div>
        )
    }

    function kitCustomToolbar() {

        return (
            <GridToolbarContainer>
                <KitCustomNewPagesizeoptions />
                <KitCustomNewTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {

        return (
            <GridFooterContainer style={{ justifyContent: 'end' }}>
                <Pagination
                    color="primary"
                    shape="circular"
                    page={lineitemsettings && lineitemsettings.meta && lineitemsettings.meta.current_page}
                    count={lineitemsettings && lineitemsettings.meta && lineitemsettings.meta.last_page}
                    onChange={onChangePagination}
                />
            </GridFooterContainer>
        );
    }
    function newCustomPagination() {

        return (
            <GridFooterContainer style={{ justifyContent: 'end' }}>
                <Pagination
                    color="primary"
                    shape="circular"
                    page={newlineitemsettings && newlineitemsettings.newMeta && newlineitemsettings.newMeta.current_page}
                    count={newlineitemsettings && newlineitemsettings.newMeta && newlineitemsettings.newMeta.last_page}
                    onChange={onNewChangePagination}
                />
            </GridFooterContainer>
        );
    }

    function kitCustomPagination() {

        return (
            <GridFooterContainer style={{ justifyContent: 'end' }}>
                <Pagination
                    color="primary"
                    shape="circular"
                    page={kitlineitemsettings && kitlineitemsettings.kitMeta && kitlineitemsettings.kitMeta.current_page}
                    count={kitlineitemsettings && kitlineitemsettings.kitMeta && kitlineitemsettings.kitMeta.last_page}
                    onChange={onKitChangePagination}
                />
            </GridFooterContainer>
        );
    }

    return (
        <>
            {(importproduct && importproduct.notification && importproduct.notification.show && importproduct.notification.messageContent) &&
                <Notification
                    is_open={importproduct.notification.show}
                    messageType={importproduct.notification.messageType}
                    messages={importproduct.notification.messageContent}
                    handleClose={() => dispatch(resetLineItemSettingsState())}
                />
            }
            {(lineitemsnotify && lineitemsnotify.notification && lineitemsnotify.notification.show && lineitemsnotify.notification.messageContent) &&
                <Notification
                    is_open={lineitemsnotify.notification.show}
                    messageType={lineitemsnotify.notification.messageType}
                    messages={lineitemsnotify.notification.messageContent}
                    handleClose={() => dispatch(resetLineItemSettingsState())}
                />
            }

            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={deleteModalStyle}>
                    <Typography sx={{ p: 2 }}>Are you sure want to delete this product?<br />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <span style={{ margin: '0 10px' }}>
                                <Button
                                    variant="contained"
                                    style={{ margin: "10px 0" }}
                                    onClick={(event) => {
                                        deleteaddress(deleteid)
                                    }}
                                >
                                    Yes
                                </Button>
                            </span>
                            <span>
                                <Button
                                    variant="outlined"
                                    style={{ margin: "10px 0" }}
                                    onClick={deleteModalClose}
                                >
                                    No
                                </Button>
                            </span>
                        </div>
                    </Typography>
                </Box>
            </Modal>

            <Modal
                open={modalImportVisible}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                        <CardHeader title='Import New Products' action={
                            <div>
                                <IconButton aria-label="settings" onClick={onModalImportClose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        } />
                        {importproduct && importproduct.loading === true &&
                            <LinearProgress />
                        }
                        <Divider />
                        <CardContent>
                            <div style={{ margin: '15px 0', paddingTop: '25px', textAlign: 'center', }}>
                                <label htmlFor="contained-button-file">
                                    <Input accept=".csv" id="contained-button-file" onChange={onFileUpload} key={fileName} name='import_recipient_address_book' multiple type="file" />
                                    <Button variant="contained" component="span" style={{ margin: '0 10px' }} disabled={buttonUploadDisabled}>
                                        Upload
                                    </Button>
                                   {value!==2 && <a href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/sample/PRODUCTS_DATA_SAMPLE.csv">Sample New Products CSV</a>}
                                   {value===2 && <a href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/sample/PRODUCTS_KIT_DETAILS_SAMPLE.csv">Sample New Products CSV</a>}
                                </label>
                                {fileName && <><br /><span style={{ fontSize: '10px' }}>Filename : {fileName}</span></>}
                                <div>
                                    <Button variant="outlined" onClick={onSubmit} style={{ margin: '15px 15px' }} disabled={buttonSubmitDisabled}>
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
            <Modal
                open={modalVisible}
                onClose={onModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Card sx={{ minWidth: 800 }} className="sc--cardhead--details">
                        <CardHeader title={modalTitle}  action={
                            <div>
                                <IconButton aria-label="settings" onClick={onModalClose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        }/>
                        <Divider />
                        <CardContent
                           sx={{
                                ...(value !== 2 && {
                                    maxHeight: '60vh',
                                    overflowY: 'auto',
                                }),
                                paddingBottom: '0px !important' // reserve space for sticky footer
                                }}>
                                    <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                        {(value!==2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && <>
                                            <FormControl
                                                variant="standard"
                                                className="help-text-error"
                                                style={{ width: "100%", margin: '8px' }}
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">Is Kit*</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-error"
                                                    name="isKit"
                                                    defaultValue={isKit}
                                                    onChange={e => {
                                                        dispatch(fetchSkuINfo("","INVENTORY"))
                                                        setIsKit(e.target.value)
                                                    }}
                                                    label="IS KIT*"
                                                    disabled={modalTitle === 'Items Edit' || modalTitle === 'New Items Edit'} // ✅ added condition
                                                >
                                                    <MenuItem value={false}>False</MenuItem>
                                                    <MenuItem value={true}>True</MenuItem>

                                                </Select>
                                            </FormControl>
                                            </>
                                        }
                                        {(modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && <>
                                        <TextField
                                            id="outlined-read-only-input"
                                            label="Sku"
                                            name="sku"
                                            defaultValue={sku}
                                            onInput={e => {
                                                setSku(e.target.value)
                                                setSkuError("")
                                            }}
                                            InputProps={{ readOnly: (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? true : false }}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant={(modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? "filled" : "standard"}
                                            error={skuError}
                                            helperText={skuError}
                                        />
                                        </>
                                        }
                                    </div>
                                   
                                {(value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && <>
                                    <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                        <TextField
                                            label="Product Id"
                                            name="product_id"
                                            defaultValue={productId}
                                            onInput={e => {
                                                setProductId(e.target.value)
                                            }}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant={"standard"}
                                        />
                                        <TextField
                                            label="Product Value"
                                            name="product value"
                                            defaultValue={productValue}
                                            onInput={handleProductValueInput}
                                            onBlur={handleProductValueBlur}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant={"standard"}
                                            error={productValueError}
                                            helperText={productValueError}
                                        />
                                        <TextField
                                            label="Product Description"
                                            name="product_description"
                                            defaultValue={productDescription}
                                            onInput={e => {
                                                setProductDescription(e.target.value)
                                                setProductDescError("")
                                            }}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant={"standard"}
                                            error={productDescError}
                                            helperText={productDescError}
                                        />
                                    </div>
                                </>}
                                {value===2 &&
                                    <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                        <TextField
                                            label="Item Sku"
                                            name="item_sku"
                                            defaultValue={itemSku}
                                            InputProps={{ readOnly: (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? true : false }}
                                            onInput={e => {
                                                    setItemSku(e.target.value)
                                                    setItemSkuError("")
                                            }}
                                            variant={(modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? "filled" : "standard"}
                                            style={{ width: "100%", margin: '8px' }}
                                            error={itemSkuError}
                                            helperText={itemSkuError}
                                        />
                                        <TextField
                                            label="Quantity"
                                            name="quantity"
                                            defaultValue={quantity}
                                            onInput={handleQuantityInput}
                                            InputProps={{ readOnly: (isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? true : false }}
                                            onBlur={handleQuantityBlur}
                                            variant={(isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? "filled" : "standard"}
                                            style={{ width: "100%", margin: '8px' }}
                                            error={quantityError}
                                            helperText={quantityError}
                                        />
                                    </div>
                                }
                                <div className="sc--form--center"  style={{ ...(value !== 2 && { margin: '20px 0' }) }}>
                                    {(!isKit && value!==2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') &&
                                        <TextField
                                            label="Stock Quantity"
                                            name="quantity"
                                            defaultValue={quantity}
                                            onInput={handleQuantityInput}
                                            InputProps={{ readOnly: (isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? true : false }}
                                            onBlur={handleQuantityBlur}
                                            variant={(isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? "filled" : "standard"}
                                            style={{ width: "100%", margin: '8px' }}
                                            error={quantityError}
                                            helperText={quantityError}
                                        />
                                    }
                                    {(!isKit && value!==2) &&
                                        <TextField
                                            label="Currency"
                                            name="currency"
                                            defaultValue={currency}
                                            onInput={handleInput}
                                            onBlur={handleBlur}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant={"standard"}
                                            error={currencyError}
                                            helperText={currencyError}
                                        />
                                    }
                                </div>
                                
                                
                            
                                <div className="sc--form--center"  style={{ ...(value !== 2 && { margin: '20px 0' }) }}>
                                    {(value !== 2 && !isKit) && <>
                                        <Autocomplete
                                            className="help-text-error"
                                            disablePortal
                                            name="origin_country_code"
                                            id="country-select-demo"
                                            sx={{ width: "100%", margin: '8px' }}
                                            options={filteredCountryData}
                                            autoHighlight
                                            loading={country_code && country_code.loading}
                                            getOptionLabel={(option) => option.name}
                                            value={getSelectedCountry(originCountryCode)}
                                            renderOption={(props, option) => (
                                                <MenuItem {...props} value={option.code} key={option.code}>
                                                    {option.icon} {option.name}
                                                </MenuItem>
                                            )}
                                            onChange={(event, value) => {
                                                if (value !== null) {
                                                    setOriginCountryCode(value.code);
                                                    setOriginCountryCodeError("")
                                                } else {
                                                    setOriginCountryCode("");
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country of Origin"
                                                    variant="standard"
                                                    helperText={originCountryCodeError}
                                                />
                                            )}
                                        />
                                    </>}
                                    {(!isKit && value!==2 &&   modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') &&
                                        <TextField
                                            label="Hs Code"
                                            name="tag_name"
                                            defaultValue={hsTariffcode}
                                            onInput={handleHscodeInput}
                                            onBlur={handleHsCodeBlur}
                                            style={{ width: "100%", margin: '8px' }}
                                            variant="standard"
                                            error={hsTariffcodeError}
                                            helperText={hsTariffcodeError}
                                        />
                                    }
                                </div>

                                {isKit && modalVisible && (
                                    <>
                                        {kitLoading && (
                                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                                <CircularProgress />
                                                <div>Loading kit details…</div>
                                            </div>
                                        )}
                                        {!kitLoading && kitReady && (
                                            <KitDetailsForm
                                                ref={kitFormRef}
                                                modalTitle={modalTitle}
                                                isKit={selectedItem?.is_kit}
                                                initialRows={kitItemDetails}
                                                skuOnly={skuInfo}
                                            />
                                        )}
                                    </>
                                )}

                                {/* {isKit && kitReady &&(
                                    <KitDetailsForm
                                        modalTitle="Items Edit"
                                        isKit={selectedItem?.is_kit}
                                        initialRows={kitItemDetails} // pass the array of items
                                        ref={kitFormRef}
                                    />
                                )} */}
                            {/* Sticky footer */}
                            <Box
                            sx={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: '#fff',
                                textAlign: 'right',
                                zIndex: 1
                            }}
                            > <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                <Button variant="outlined" onClick={e => handleSubmit(e, modalTitle,value)} >Submit</Button>
                            </div></Box>
                           
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
            <Card sx={{ minWidth: 1000, boxShadow: 'unset' }} className="sc--cardhead--details">
                <CardHeader
                    title={
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6">Inventory</Typography>

                        {/* Centered Search + Dropdown */}
                        <Box display="flex" alignItems="center" gap={2} sx={{ flexGrow: 1, justifyContent: "center" }}>
                            <TextField
                            variant="standard"
                            placeholder="Search SKU "
                            value={skuFilter}
                            onChange={(e) => setSkuFilter(e.target.value)}
                            style={{ minWidth: 150,position:'relative',top:'10px' }}
                            />

                            {value === 0 &&
                                <FormControl variant="standard" style={{ minWidth: 120 }}>
                                <InputLabel id="is-kit-label">Is Kit*</InputLabel>
                                <Select
                                    labelId="is-kit-label"
                                    id="is-kit-select"
                                    name="isKit"
                                    value={isKitFilter}
                                    onChange={e => {
                                            setIsKitFilter(e.target.value)
                                        }}
                                    label="Is Kit*"
                                >   
                                    <MenuItem value={""}>All</MenuItem>
                                    <MenuItem value={false}>False</MenuItem>
                                    <MenuItem value={true}>True</MenuItem>
                                </Select>
                                </FormControl>
                            }
                        </Box>
                        

                        {/* Right-Aligned Bulk Edit Button */}
                        {(checkedIds && checkedIds.length >= 1) && (
                            <Button
                            variant="contained"
                            onClick={() => {
                                setModalVisible(true);
                                setModalTitle(value === 1 ? "Bulk Edit" : "New Products Bulk Edit");
                            }}
                            >
                            Bulk Edit
                            </Button>
                        )}
                        </Box>
                    }
                />

                <CardContent style={{ padding: '10px 10px' }}>
                    <div className="scmaincard">
                        <div>
                            <Box className="deliveries_tab" sx={{ border: '1px solid', borderColor: 'divider', borderBottom: 'unset', background: '#fff' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div>
                                        <Tabs value={value} onChange={tabOnClick} aria-label="basic tabs example">
                                            <Tab label="Complete" />
                                            <Tab label="Missing" />
                                            <Tab label="Kit Details" />
                                        </Tabs>
                                    </div>
                                    {(value === 0) &&
                                        <div>
                                            <Button variant="contained" onClick={() => {
                                                handleAddNew()
                                                setModalVisible(true)
                                                setModalTitle("Add New")
                                            }}>Add New</Button>
                                            <Tooltip title="Import" placement="top-start">
                                                <IconButton onClick={() => { 
                                                    setModalImportVisible(true) 
                                                    setButtonUploadDisabled(false)
                                                    }}>
                                                    <UploadIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                            </Box>
                        </div>
                        {value === 1 &&
                            <div style={{ width: '100%', background: '#fff' }}>
                                <DataGrid
                                    style={{ paddingTop: "35px" }}
                                    getRowId={(row) => row.sku}
                                    rows={lineitemsettings && lineitemsettings.data}
                                    columns={columns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, lineitemsettings.data) }}
                                    rowSelectionModel={checkedIds}
                                    disableRowSelectionOnClick
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: CustomPagination,
                                        toolbar: CustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((lineitemsettings && lineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </div>
                        }
                        {value === 0 &&
                            <div style={{ width: '100%', background: '#fff' }}>
                                <DataGrid
                                    style={{ paddingTop: "35px" }}
                                    getRowId={(row) => row.sku}
                                    rows={newlineitemsettings && newlineitemsettings.data}
                                    columns={newColumns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, newlineitemsettings.data) }}
                                    rowSelectionModel={checkedIds}
                                    isRowSelectable={(params) => !params.row.is_kit}
                                    disableRowSelectionOnClick
                                    sortingMode="server" // Enable server-side sorting
                                    sortingOrder={['asc', 'desc']}
                                    onSortModelChange={onSortChange} // Call handler on header click
                                    sortModel={
                                        (value === 1 ? meta.sorting : (value === 0 ? newMeta.sorting : kitMeta.sorting)) 
                                        ? JSON.parse(value === 1 ? meta.sorting : (value === 0 ? newMeta.sorting : kitMeta.sorting)) 
                                        : []
                                    }
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: newCustomPagination,
                                        toolbar: newCustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((newlineitemsettings && newlineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </div>
                        }
                        {value === 2 &&
                            <div style={{ width: '100%', background: '#fff' }}>
                                <DataGrid
                                    style={{ paddingTop: "35px" }}
                                    getRowId={(row) => row.id}
                                    rows={kitlineitemsettings && kitlineitemsettings.data}
                                    columns={kitColumns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    // checkboxSelection
                                    // onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, kitlineitemsettings.data) }}
                                    disableRowSelectionOnClick
                                    // --- ADDED FOR SORTING ---
                                    sortingMode="server" 
                                    sortingOrder={['asc', 'desc']}
                                    onSortModelChange={onSortChange} 
                                    sortModel={kitMeta.sorting ? JSON.parse(kitMeta.sorting) : []}
                                    // -------------------------
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: kitCustomPagination,
                                        toolbar: kitCustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((kitlineitemsettings && kitlineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </div>
                        }
                    </div>
                </CardContent>
            </Card >

        </>
    )
}

export default ProductLineItemsPage;
